export const getStates = country => {
    switch (country) {
        case 'US':
            return usStates
        case 'BR':
            return brazilStates
        default:
            return canadaStates
    }
}

export const getStateValue = (country = 'CA') => value => {
    const states = getStates(country)

    return states.find(state => state.value === value) || ''
}

export const getCountryValue = value => countries.find(country => country.value === value)

export const CAPostalCodeRegex = /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$/
export const CAPostalCodeRegexString = '^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$'

const addBrazilConditionally = () =>
    window.COUNTRY_PURCHASE_FLOW === 'BR'
        ? [
              {
                  label: 'Brazil',
                  value: 'BR',
              },
          ]
        : []

export const countries = [
    {
        label: 'United States',
        value: 'US',
    },
    {
        label: 'Canada',
        value: 'CA',
    },
    ...addBrazilConditionally(),
]

export const canadaStates = [
    {
        label: 'Alberta',
        value: 'AB',
    },
    {
        label: 'British Columbia',
        value: 'BC',
    },
    {
        label: 'Manitoba',
        value: 'MB',
    },
    {
        label: 'New Brunswick',
        value: 'NB',
    },
    {
        label: 'Newfoundland and Labrador',
        value: 'NL',
    },
    {
        label: 'Northwest Territories',
        value: 'NT',
    },
    {
        label: 'Nova Scotia',
        value: 'NS',
    },
    {
        label: 'Nunavut',
        value: 'NU',
    },
    {
        label: 'Ontario',
        value: 'ON',
    },
    {
        label: 'Prince Edward Island',
        value: 'PE',
    },
    {
        label: 'Quebec',
        value: 'QC',
    },
    {
        label: 'Saskatchewan',
        value: 'SK',
    },
    {
        label: 'Yukon',
        value: 'YT',
    },
]

export const usStates = [
    {
        label: 'Alabama',
        value: 'AL',
    },
    {
        label: 'Alaska',
        value: 'AK',
    },
    {
        label: 'Arizona',
        value: 'AZ',
    },
    {
        label: 'Arkansas',
        value: 'AR',
    },
    {
        label: 'California',
        value: 'CA',
    },
    {
        label: 'Colorado',
        value: 'CO',
    },
    {
        label: 'Connecticut',
        value: 'CT',
    },
    {
        label: 'Delaware',
        value: 'DE',
    },
    {
        label: 'District of Columbia',
        value: 'DC',
    },
    {
        label: 'Florida',
        value: 'FL',
    },
    {
        label: 'Georgia',
        value: 'GA',
    },
    {
        label: 'Hawaii',
        value: 'HI',
    },
    {
        label: 'Idaho',
        value: 'ID',
    },
    {
        label: 'Illinois',
        value: 'IL',
    },
    {
        label: 'Indiana',
        value: 'IN',
    },
    {
        label: 'Iowa',
        value: 'IA',
    },
    {
        label: 'Kansas',
        value: 'KS',
    },
    {
        label: 'Kentucky',
        value: 'KY',
    },
    {
        label: 'Louisiana',
        value: 'LA',
    },
    {
        label: 'Maine',
        value: 'ME',
    },
    {
        label: 'Maryland',
        value: 'MD',
    },
    {
        label: 'Massachusetts',
        value: 'MA',
    },
    {
        label: 'Michigan',
        value: 'MI',
    },
    {
        label: 'Minnesota',
        value: 'MN',
    },
    {
        label: 'Mississippi',
        value: 'MS',
    },
    {
        label: 'Missouri',
        value: 'MO',
    },
    {
        label: 'Montana',
        value: 'MT',
    },
    {
        label: 'Nebraska',
        value: 'NE',
    },
    {
        label: 'Nevada',
        value: 'NV',
    },
    {
        label: 'New Hampshire',
        value: 'NH',
    },
    {
        label: 'New Jersey',
        value: 'NJ',
    },
    {
        label: 'New Mexico',
        value: 'NM',
    },
    {
        label: 'New York',
        value: 'NY',
    },
    {
        label: 'North Carolina',
        value: 'NC',
    },
    {
        label: 'North Dakota',
        value: 'ND',
    },
    {
        label: 'Ohio',
        value: 'OH',
    },
    {
        label: 'Oklahoma',
        value: 'OK',
    },
    {
        label: 'Oregon',
        value: 'OR',
    },
    {
        label: 'Pennsylvania',
        value: 'PA',
    },
    {
        label: 'Rhode Island',
        value: 'RI',
    },
    {
        label: 'South Carolina',
        value: 'SC',
    },
    {
        label: 'South Dakota',
        value: 'SD',
    },
    {
        label: 'Tennessee',
        value: 'TN',
    },
    {
        label: 'Texas',
        value: 'TX',
    },
    {
        label: 'Utah',
        value: 'UT',
    },
    {
        label: 'Vermont',
        value: 'VT',
    },
    {
        label: 'Virginia',
        value: 'VA',
    },
    {
        label: 'Washington',
        value: 'WA',
    },
    {
        label: 'West Virginia',
        value: 'WV',
    },
    {
        label: 'Wisconsin',
        value: 'WI',
    },
    {
        label: 'Wyoming',
        value: 'WY',
    },
]

export const brazilStates = [
    {
        value: 'AC',
        label: 'Acre',
    },
    {
        value: 'AL',
        label: 'Alagoas',
    },
    {
        value: 'AP',
        label: 'Amapá',
    },
    {
        value: 'AM',
        label: 'Amazonas',
    },
    {
        value: 'BA',
        label: 'Bahia',
    },
    {
        value: 'CE',
        label: 'Ceará',
    },
    {
        value: 'DF',
        label: 'Distrito Federal',
    },
    {
        value: 'ES',
        label: 'Espírito Santo',
    },
    {
        value: 'GO',
        label: 'Goiás',
    },
    {
        value: 'MA',
        label: 'Maranhão',
    },
    {
        value: 'MT',
        label: 'Mato Grosso',
    },
    {
        value: 'MS',
        label: 'Mato Grossodo Sul',
    },
    {
        value: 'MG',
        label: 'Minas Gerais',
    },
    {
        value: 'PA',
        label: 'Pará',
    },
    {
        value: 'PB',
        label: 'Paraíba',
    },
    {
        value: 'PR',
        label: 'Paraná',
    },
    {
        value: 'PE',
        label: 'Pernambuco',
    },
    {
        value: 'PI',
        label: 'Piauí',
    },
    {
        value: 'RJ',
        label: 'Rio de Janeiro',
    },
    {
        value: 'RN',
        label: 'Rio Grande do Norte',
    },
    {
        value: 'RS',
        label: 'Rio Grande do Sul',
    },
    {
        value: 'RO',
        label: 'Rondônia',
    },
    {
        value: 'RR',
        label: 'Roraima',
    },
    {
        value: 'SC',
        label: 'Santa Catarina',
    },
    {
        value: 'SP',
        label: 'São Paulo',
    },
    {
        value: 'SE',
        label: 'Sergipe',
    },
    {
        value: 'TO',
        label: 'Tocantins',
    },
]
